const { getElements } = window.BAO.Utils

class CharityProgress extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['widget']
  }

  connectedCallback () {
    super.connectedCallback()

    document.addEventListener('swell:setup', () => {
      if (this.hasAttribute('toggle-redeem-button')) {
        this.setRedeemButtonVisibility()
        this.observeWidgetMutations()
      }
    })
  }

  setupListeners () {
    super.setupListeners()

    if (this.els['redeem-proxy']) {
      this.els['redeem-proxy'].elements.forEach(item => {
        this.listeners.add(
          item,
          'click',
          this.handleRedeemProxyClick.bind(this),
        )
      })
    }
  }

  observeWidgetMutations () {
    const observer = new MutationObserver(() => {
      this.setRedeemButtonVisibility()
    })

    observer.observe(this.els.widget.element, {
      childList: true,
      subtree: true,
    })
  }

  handleRedeemProxyClick () {
    const redeemDiscountButtons = this.availableRedeemDiscountButtons
    const buttonToClick = this.buttonToClick

    if (redeemDiscountButtons.length === 0 && buttonToClick.length === 0) {
      return
    }

    const parentEl = buttonToClick.parentNode
    buttonToClick.click()

    setTimeout(() => {
      const buttonToClickConfirm = parentEl.querySelector(
        '.yotpo-redemption-confirmation-option-confirm-btn',
      )

      if (buttonToClickConfirm) {
        buttonToClickConfirm.click()

        this.els['redeem-text'].element.innerText = this.els[
          'redeem-text'
        ].element.dataset.successText
      }

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('loyalty:update'))
      }, 3000)
    }, 500)
  }

  setRedeemButtonVisibility () {
    if (this.buttonToClick?.length === 0) {
      return
    }
    const isVisible = this.buttonToClick?.disabled !== true

    this.els['redeem-proxy'].elements.forEach(item => {
      item.setAttribute('aria-hidden', !isVisible)
      item.setAttribute('aria-loading', false)
    })

    this.els['redeem-backup'].elements.forEach(item => {
      item.setAttribute('aria-hidden', isVisible)
    })
  }

  setActiveDiscounts () {
    this.els.discount.elements.forEach(discount => {
      const pointsForDiscount = Number(discount.dataset.requiredPoints)
      const state =
        pointsForDiscount > this.currentPoints ? 'inactive' : 'active'

      discount.dataset.state = state
    })
  }

  get availableRedeemDiscountButtons () {
    return this.redeemDiscountButtons.filter(
      button => button.disabled === false,
    )
  }

  get buttonToClick () {
    return this.redeemDiscountButtons.find(button => {
      const label = button.parentNode
        .querySelector('.yotpo-redemption-option-reward')
        .innerHTML.trim()

      return label === this.dataset.selectedReward
    })
  }

  get redeemDiscountButtons () {
    /** @type {HTMLButtonElement[]} */
    return getElements('.yotpo-redemption-option-redeem-button', {
      context: this.els.widget.element,
    })
  }
}

if (!customElements.get('charity-progress')) {
  customElements.define('charity-progress', CharityProgress)
}
